import { createDefaultFieldFactory, FieldTypes } from '@sitecore-jss/sitecore-jss-react-forms';
import TextField from './components/textField';
import EmailField from './components/emailField';
import NumberField from './components/numberField';
import TelephoneField from './components/telephoneField';
import PasswordField from './components/passwordField';
import MultipleLineTextField from './components/multipleLineTextField';
import CheckboxField from './components/checkboxField';
import CheckboxList from './components/checkboxList';
import DropdownList from './components/dropdownList';
import FileUploadField from './components/fileUploadField';
import RadioGroup from './components/radioGroup';
import SingleLineText from './components/singleLineText';
import DateField from './components/dateField';
import ZipCodeField from './components/zipCodeField';
import GdprConsentField from './components/gdprConsentField';
import PageTitle from './components/pageTitleField';
import PageUrl from './components/pageUrlField';
import ReCaptchaField from './components/reCaptchaField';
import ProductSelector from './components/productSelector';
import CountryStateField from './components/countryStateField';
import DealerLocator from './components/dealerLocator';
import CustomNumberField from './components/customNumberField';
import FormPageIdentifierField from './components/formPageIdentifierField';
import Button from './components/button';
import TimeField from './components/timeField';

import customFieldTypes from './types/field.types';
import MarketingConsentField from './components/marketingConsentField';
import DynamicProductSelector from './components/dynamicProductSelector';
import LeadDocument from './components/leadDocument';
import CityField from './components/cityField';
import CustomAddressField from './components/customAddressField';

const fieldFactory = createDefaultFieldFactory();

fieldFactory.setComponent(FieldTypes.SingleLineText, TextField);
fieldFactory.setComponent(FieldTypes.NumberField, NumberField);
fieldFactory.setComponent(FieldTypes.Email, EmailField);
fieldFactory.setComponent(FieldTypes.Telephone, TelephoneField);
fieldFactory.setComponent(FieldTypes.Password, PasswordField);
fieldFactory.setComponent(FieldTypes.MultipleLineText, MultipleLineTextField);
fieldFactory.setComponent(FieldTypes.Checkbox, CheckboxField);
fieldFactory.setComponent(FieldTypes.CheckboxList, CheckboxList);
fieldFactory.setComponent(FieldTypes.DropdownList, DropdownList);
fieldFactory.setComponent(FieldTypes.FileUpload, FileUploadField);
fieldFactory.setComponent(FieldTypes.RadioButtonList, RadioGroup);
fieldFactory.setComponent(FieldTypes.SingleLineText, SingleLineText);
fieldFactory.setComponent(FieldTypes.DateField, DateField);
fieldFactory.setComponent(FieldTypes.Button, Button);

/* Custom Field Types */
fieldFactory.setComponent(customFieldTypes.firstNameFieldTypeItemId, TextField);
fieldFactory.setComponent(customFieldTypes.lastNameFieldTypeItemId, TextField);
fieldFactory.setComponent(customFieldTypes.companyNameFieldTypeItemId, TextField);
fieldFactory.setComponent(customFieldTypes.emailFieldTypeItemId, EmailField);
fieldFactory.setComponent(customFieldTypes.zipCodeFieldTypeItemId, ZipCodeField);
fieldFactory.setComponent(customFieldTypes.phoneNumberFieldTypeItemId, TelephoneField);
fieldFactory.setComponent(customFieldTypes.mobileNumberFieldTypeItemId, TelephoneField);
fieldFactory.setComponent(customFieldTypes.addressFieldTypeItemId, TextField);
fieldFactory.setComponent(customFieldTypes.cityFieldTypeItemId, CityField);
fieldFactory.setComponent(customFieldTypes.gdprConsentFieldTypeItemId, GdprConsentField);
fieldFactory.setComponent(customFieldTypes.productSelectorFieldTypeItemId, ProductSelector);
fieldFactory.setComponent(customFieldTypes.preferredCommunicationFieldTypeItemId, RadioGroup);
fieldFactory.setComponent(customFieldTypes.countryStateDropdownFieldTypeItemId, CountryStateField);
fieldFactory.setComponent(customFieldTypes.pageTitleFieldTypeItemId, PageTitle);
fieldFactory.setComponent(customFieldTypes.pageUrlFieldTypeItemId, PageUrl);
fieldFactory.setComponent(customFieldTypes.decisionRoleFieldTypeItemId, DropdownList);
fieldFactory.setComponent(customFieldTypes.purchaseTimingFieldTypeItemId, DropdownList);
fieldFactory.setComponent(customFieldTypes.recaptchaFieldTypeItemId, ReCaptchaField);
fieldFactory.setComponent(customFieldTypes.purchaseIntentionFieldTypeItemId, DropdownList);
fieldFactory.setComponent(customFieldTypes.contactReasonFieldTypeItemId, DropdownList);
fieldFactory.setComponent(customFieldTypes.notes1FieldTypeItemId, MultipleLineTextField);
fieldFactory.setComponent(customFieldTypes.codePromotionFieldTypeItemId, TextField);
fieldFactory.setComponent(customFieldTypes.initiativeSourceReportFieldTypeItemId, TextField);
fieldFactory.setComponent(customFieldTypes.initiativeSourceReportDetailFieldTypeItemId, TextField);
fieldFactory.setComponent(customFieldTypes.productOfInterestFieldTypeItemId, DropdownList);
fieldFactory.setComponent(customFieldTypes.customProductOfInterestFieldTypeItemId, DropdownList);
fieldFactory.setComponent(customFieldTypes.dealerNotesFieldTypeItemId, TextField);
fieldFactory.setComponent(customFieldTypes.address2FieldTypeItemId, TextField);
fieldFactory.setComponent(customFieldTypes.jobTitleFieldTypeItemId, TextField);
fieldFactory.setComponent(customFieldTypes.leadManagementCampaignFieldTypeItemId, TextField);
fieldFactory.setComponent(customFieldTypes.provinceFieldTypeItemId, TextField);
fieldFactory.setComponent(customFieldTypes.delaerLocatorFieldTypeItemId, DealerLocator);
fieldFactory.setComponent(customFieldTypes.customNumberFieldTypeItemId, CustomNumberField);
fieldFactory.setComponent(customFieldTypes.BusinessSegmentFieldTypeItemId, DropdownList);
fieldFactory.setComponent(customFieldTypes.formPageIdentifierFieldTypeItemId, FormPageIdentifierField);
fieldFactory.setComponent(customFieldTypes.timeFieldTypeItemId, TimeField);
fieldFactory.setComponent(customFieldTypes.dealerNotesDropdownListFieldTypeItemId, DropdownList);
fieldFactory.setComponent(customFieldTypes.dealerNotesCheckboxListFieldTypeItemId, CheckboxList);
fieldFactory.setComponent(customFieldTypes.dealerNotesRadioGroupFieldTypeItemId, RadioGroup);
fieldFactory.setComponent(customFieldTypes.marketingConsentTypeItemId, MarketingConsentField);
fieldFactory.setComponent(customFieldTypes.dynamicProductSelector, DynamicProductSelector);
fieldFactory.setComponent(customFieldTypes.leadDocumentId, LeadDocument);
fieldFactory.setComponent(customFieldTypes.LeadPropertyNameId,TextField);
fieldFactory.setComponent(customFieldTypes.customAddressFieldTypeItemId, CustomAddressField);

export default fieldFactory;
